import {Parser, ParseResult} from "./parser";
import {BlockMarkupItemType, ListMarkup} from "../markup.interface";

function isBulletStart(markup: string, pos: number): boolean {
    return markup[pos] === '-' && markup[pos + 1] === ' ';
}

function isOrderedStart(markup: string, pos: number): boolean {
    return /^\d+\. /.test(markup.slice(pos, pos + 6));
}

function lineEndIndex(markup: string, from: number): number {
    const nl = markup.indexOf('\n', from);
    return nl === -1 ? markup.length - 1 : nl;
}

function itemContent(markup: string, lineStart: number, ordered: boolean): string {
    if (ordered) {
        const m = markup.slice(lineStart).match(/^\d+\. /);
        return markup.substring(lineStart + m![0].length, lineEndIndex(markup, lineStart));
    }
    return markup.substring(lineStart + 2, lineEndIndex(markup, lineStart));
}

export const listParser: Parser = {
    matches(markup: string, startIndex: number): boolean {
        const atLineStart = startIndex === 0 || markup[startIndex - 1] === '\n';
        if (!atLineStart) return false;
        return isBulletStart(markup, startIndex) || isOrderedStart(markup, startIndex);
    },

    parse(markup: string, startIndex: number): ParseResult {
        const ordered = isOrderedStart(markup, startIndex);
        const items: string[] = [];
        let pos = startIndex;

        while (pos < markup.length) {
            if (!isBulletStart(markup, pos) && !isOrderedStart(markup, pos)) break;
            if (isOrderedStart(markup, pos) !== ordered) break;

            const end = lineEndIndex(markup, pos);
            items.push(itemContent(markup, pos, ordered));

            if (end >= markup.length - 1) { pos = end; break; }

            const next = end + 1;
            if (!isBulletStart(markup, next) && !isOrderedStart(markup, next)) { pos = end; break; }
            if (isOrderedStart(markup, next) !== ordered) { pos = end; break; }

            pos = next;
        }

        const item: ListMarkup = { type: BlockMarkupItemType.List, ordered, items };
        return { item, lastIndex: pos };
    },
};
